export const sentryIgnoredErrors = [
  // Network errors
  'Network Error',
  'network error',
  'Failed to fetch',
  'AbortError',
  'TimeoutError',
  'ECONNABORTED',
  'ECONNREFUSED',
  'ECONNRESET',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_CANCELED',
  'ERR_CONNECTION_REFUSED',
  'cancelled',
  'cancelado',

  // Browser extensions
  'chrome-extension://',
  'moz-extension://',
  'webkit-masked-url:',

  // Third-party scripts
  'jQuery is not defined',
  '$ is not defined',
  'gtag is not defined',
  'fbq is not defined',
  'dataLayer is not defined',

  // Genéricas
  '__AutoFillPopupClose__',
  "Can't find variable: Chartboost",
  'window.TelegramGameProxy.receiveEvent',
  'xbrowser is not defined',
  'swbrowser is not defined',
  'saveAndroidOneSignalUserId is not defined',
  'Java exception was raised during method invocation',
  'Java object is gone',
  'Error invoking enableButtonsClickedMetaDataLogging: Java object is gone',
  "Cannot read properties of null (reading 'ownerDocument')",
  "reading 'domInteractive'",
  'Non-Error exception captured',
  'Non-Error promise rejection captured',
  'EADDRINUSE',
  'econnaborted',
  'err_canceled',
  'err_network',

  // Revisar manualmente (el usuario depurará)
  'unauthorized_access',
  'not_enough_permissions',
  'session_required',
  'subscription_required',
  'email_rate_limit_exceeded',
  'OTP_by_app_generated_code',
  'banking_product_reconcile_feature_already_disabled',
  'banking_product_reconcile_feature_already_enabled',
  'tags_text_is_a_required_field',
  'import_tax_group_not_found',
  'series_not_allowed',
  'invoice_number_must_match_sequence',
  'rectifying_invoice_client_mismatch',
  'rectifying_invoice_must_have_associated_invoice',
  '_satellite is not defined',
  'jb',
  'swift_not_ending_in_xxx',
]

export const sentryDeniedUrls = [
  /googletagmanager\.com/i,
  /google-analytics\.com/i,
  /gtag\/js/i,
  /googleadservices\.com/i,
  /facebook\.com/i,
  /connect\.facebook\.net/i,
]
